import { render, staticRenderFns } from "./RedefinirSenha.vue?vue&type=template&id=6e928ae4&scoped=true&"
import script from "./RedefinirSenha.vue?vue&type=script&lang=js&"
export * from "./RedefinirSenha.vue?vue&type=script&lang=js&"
import style0 from "./RedefinirSenha.vue?vue&type=style&index=0&id=6e928ae4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e928ae4",
  null
  
)

export default component.exports